import { render, staticRenderFns } from "./BroadcasterSelect.vue?vue&type=template&id=55f5f32b&scoped=true&"
import script from "./BroadcasterSelect.vue?vue&type=script&lang=ts&"
export * from "./BroadcasterSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcasterSelect.vue?vue&type=style&index=0&id=55f5f32b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5f32b",
  null
  
)

export default component.exports